import { RiCalendarCheckLine } from "react-icons/ri";
import { FaCalculator, FaRegChartBar } from "react-icons/fa";
import "./site.scss";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  FiArrowLeft,
  FiArrowRight,
  FiChevronRight,
  FiPlayCircle,
} from "react-icons/fi";
import CardComponent from "../../components/card-component";
import { HeaderComponent } from "../../components/header-site";
import { FooterComponent } from "../../components/footer-site";
import { UserTypeCard } from "../../components/user-type-card";
import { FeatureDetailCard } from "../../components/feature-detail-card";
import { PlansList } from "../../api/interfaces";
import i18next, { t } from "i18next";
import UserService from "../../services/UserService";
import { useLanguage } from "../../contexts/language";
import { transformNumber } from "../../utils/NumberFormat";
import { DownloadAppSection } from "../../components/download-app-section/DownloadAppSection";
import { LocationSection } from "../../components/location-section/LocationSection";
import { SolutionSection } from "../../components/solution-section/SolutionSection";
const HeroFleetBg = require("../../assets/images/airplane-entrance.png");
const WizeWingsLogoM = require("../../assets/images/Logo02Blue6.png");
const DiscoverP1Image1 = require("../../assets/images/DiscoverP1Image1.png");
const DiscoverP1Image2 = require("../../assets/images/DiscoverP1Image2.png");

//carrossel 1
const APP_IMAGE_1 = require("../../assets/images/carrossel-app-images/image-1.png");
const APP_IMAGE_2 = require("../../assets/images/carrossel-app-images/image-2.png");
const APP_IMAGE_3 = require("../../assets/images/carrossel-app-images/image-3.png");
const APP_IMAGE_4 = require("../../assets/images/carrossel-app-images/image-4.png");
const APP_IMAGE_5 = require("../../assets/images/carrossel-app-images/image-5.png");
const APP_IMAGE_6 = require("../../assets/images/carrossel-app-images/image-6.png");
const APP_IMAGE_7 = require("../../assets/images/carrossel-app-images/image-7.png");
const APP_IMAGE_8 = require("../../assets/images/carrossel-app-images/image-8.png");
const APP_IMAGE_9 = require("../../assets/images/carrossel-app-images/image-9.png");

const APP_IMAGE_1_US = require("../../assets/images/carrossel-app-images-us/image-1.png");
const APP_IMAGE_2_US = require("../../assets/images/carrossel-app-images-us/image-2.png");
const APP_IMAGE_3_US = require("../../assets/images/carrossel-app-images-us/image-3.png");
const APP_IMAGE_4_US = require("../../assets/images/carrossel-app-images-us/image-4.png");
const APP_IMAGE_5_US = require("../../assets/images/carrossel-app-images-us/image-5.png");
const APP_IMAGE_6_US = require("../../assets/images/carrossel-app-images-us/image-6.png");
const APP_IMAGE_7_US = require("../../assets/images/carrossel-app-images-us/image-7.png");
const APP_IMAGE_8_US = require("../../assets/images/carrossel-app-images-us/image-8.png");
const APP_IMAGE_9_US = require("../../assets/images/carrossel-app-images-us/image-9.png");

const WEB_IMAGE_1_US = require("../../assets/images/prints-web-en/image-1.jpg");
const WEB_IMAGE_2_US = require("../../assets/images/prints-web-en/image-2.jpg");
const WEB_IMAGE_3_US = require("../../assets/images/prints-web-en/image-3.jpg");
const WEB_IMAGE_4_US = require("../../assets/images/prints-web-en/image-4.jpg");
const WEB_IMAGE_5_US = require("../../assets/images/prints-web-en/image-5.jpg");
const WEB_IMAGE_6_US = require("../../assets/images/prints-web-en/image-6.jpg");

const WEB_IMAGE_1 = require("../../assets/images/prints-web-pt/image-1.png");
const WEB_IMAGE_2 = require("../../assets/images/prints-web-pt/image-2.png");
const WEB_IMAGE_3 = require("../../assets/images/prints-web-pt/image-6.png");
const WEB_IMAGE_4 = require("../../assets/images/prints-web-pt/image-4.png");
const WEB_IMAGE_5 = require("../../assets/images/prints-web-pt/image-3.png");

const AIRPLANE_CLOCK = require("../../assets/images/mdi_airplane-clock.png");

// Intervalo entre as trocas automaticas do carrossel de features (em milissegundos)
const FEATURE_DETAILS_ROTATION_INTERVAL = 9000;

const DATA_CAROUSEL_WEB = [
  WEB_IMAGE_1,
  WEB_IMAGE_2,
  WEB_IMAGE_3,
  WEB_IMAGE_4,
  WEB_IMAGE_5,
];

const CardPlan = (props: { info: PlansList; onClick: Function }) => {
  const { info, onClick } = props;
  const [priceInfo, setPriceInfo] = useState<any>({});
  const { currentLanguage } = useLanguage();
  const onButtonClick = () => {
    onClick();
  };

  useEffect(() => {
    setPriceInfo(info.price.find((item) => item.lng === currentLanguage));
  }, [currentLanguage]);

  return (
    <div
      className="container-shadow"
      style={{
        // minWidth: 320,
        width: "70%",
        padding: 20,
        justifyContent: "space-around",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: 20,
        minHeight: 500,
      }}
    >
      <h6 style={{ paddingBottom: 20 }}>{t(info.title)}</h6>
      <p>{t("basicPlanDesc1", { people: info.people })}</p>
      <p>{t("basicPlanDesc2", { aircraft: info.aircraft })}</p>
      <h3 style={{ padding: 30, fontWeight: "bold" }}>
        {transformNumber(priceInfo?.value, priceInfo?.coin)}
      </h3>

      {/* <Button
        text={t("SELECT")}
        onClick={onButtonClick}
        className="custom-button-rounded"
        width={200}
      /> */}
    </div>
  );
};

export default function Site() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [plansList, setPlansList] = useState<PlansList[]>([]);
  const [carouselApp, setCarouselApp] = useState<any[]>([]);
  const [carouselWeb, setCarouselWeb] = useState<any[]>([]);
  const [userTypesVisible, setUserTypesVisible] = useState(false);
  const [featureDetailsVisible, setFeatureDetailsVisible] = useState(false);
  const [featureDetailsPaused, setFeatureDetailsPaused] = useState(false);
  const [heroTypedLines, setHeroTypedLines] = useState(["", "", ""]);
  const [heroActiveLine, setHeroActiveLine] = useState(0);
  const userTypesRef = useRef<HTMLDivElement | null>(null);
  const featureDetailsRef = useRef<HTMLDivElement | null>(null);
  const featureDetailsCarouselRef = useRef<HTMLDivElement | null>(null);
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    loadInitial();
  }, []);

  useEffect(() => {
    const heroTextLines = [
      t("heroFleetTitleLine1", { lng: currentLanguage }),
      t("heroFleetTitleLine2", { lng: currentLanguage }),
      t("heroFleetSubtitle", { lng: currentLanguage }),
    ];

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      setHeroTypedLines(heroTextLines);
      setHeroActiveLine(-1);
      return;
    }

    let lineIndex = 0;
    let charIndex = 0;
    let timeoutId: ReturnType<typeof setTimeout>;

    setHeroTypedLines(["", "", ""]);
    setHeroActiveLine(0);

    const typeNextCharacter = () => {
      const currentLine = heroTextLines[lineIndex];

      setHeroTypedLines((previousLines) => {
        const nextLines = [...previousLines];
        nextLines[lineIndex] = currentLine.slice(0, charIndex + 1);
        return nextLines;
      });

      charIndex += 1;

      if (charIndex < currentLine.length) {
        timeoutId = setTimeout(typeNextCharacter, 42);
        return;
      }

      lineIndex += 1;
      charIndex = 0;

      if (lineIndex < heroTextLines.length) {
        setHeroActiveLine(lineIndex);
        timeoutId = setTimeout(typeNextCharacter, 420);
      }
    };

    timeoutId = setTimeout(typeNextCharacter, 300);

    return () => clearTimeout(timeoutId);
  }, [currentLanguage, t]);

  useEffect(() => {
    const userTypesElement = userTypesRef.current;

    if (!userTypesElement) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setUserTypesVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.25 }
    );

    observer.observe(userTypesElement);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const featureDetailsElement = featureDetailsRef.current;

    if (!featureDetailsElement) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFeatureDetailsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(featureDetailsElement);

    return () => observer.disconnect();
  }, []);

  // Botao do hero: rola ate a primeira secao abaixo dele
  const scrollToFirstSection = () => {
    const nextSection = userTypesRef.current;

    if (!nextSection) {
      return;
    }

    window.scrollTo({
      top: nextSection.offsetTop - 100,
      behavior: "smooth",
    });
  };

  const scrollFeatureDetailsCarousel = (direction: "previous" | "next") => {
    const carouselElement = featureDetailsCarouselRef.current;

    if (!carouselElement) {
      return;
    }

    const firstCard = carouselElement.querySelector<HTMLElement>(
      ".feature-detail-card"
    );
    const carouselStyles = window.getComputedStyle(carouselElement);
    const carouselGap =
      parseFloat(carouselStyles.columnGap || carouselStyles.gap || "0") || 0;
    const scrollAmount =
      (firstCard?.offsetWidth || carouselElement.clientWidth) + carouselGap;
    const maxScrollLeft =
      carouselElement.scrollWidth - carouselElement.clientWidth;

    if (
      direction === "next" &&
      carouselElement.scrollLeft >= maxScrollLeft - 8
    ) {
      carouselElement.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }

    if (direction === "previous" && carouselElement.scrollLeft <= 8) {
      carouselElement.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
      return;
    }

    carouselElement.scrollBy({
      left: direction === "next" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (!featureDetailsVisible || featureDetailsPaused) {
      return;
    }

    const carouselTimer = window.setInterval(() => {
      scrollFeatureDetailsCarousel("next");
    }, FEATURE_DETAILS_ROTATION_INTERVAL);

    return () => window.clearInterval(carouselTimer);
  }, [featureDetailsVisible, featureDetailsPaused]);

  useEffect(() => {
    if (currentLanguage?.includes("pt")) {
      setCarouselApp([
        APP_IMAGE_1,
        APP_IMAGE_2,
        APP_IMAGE_3,
        APP_IMAGE_4,
        APP_IMAGE_5,
        APP_IMAGE_6,
        APP_IMAGE_7,
        APP_IMAGE_8,
        APP_IMAGE_9,
      ]);
      setCarouselWeb([
        WEB_IMAGE_1,
        WEB_IMAGE_2,
        WEB_IMAGE_3,
        WEB_IMAGE_4,
        WEB_IMAGE_5,
      ]);
    } else {
      setCarouselApp([
        APP_IMAGE_1_US,
        APP_IMAGE_2_US,
        APP_IMAGE_3_US,
        APP_IMAGE_4_US,
        APP_IMAGE_5_US,
        APP_IMAGE_6_US,
        APP_IMAGE_9_US,
        APP_IMAGE_7_US,
        APP_IMAGE_8_US,
      ]);
      setCarouselWeb([
        WEB_IMAGE_1_US,
        WEB_IMAGE_2_US,
        WEB_IMAGE_3_US,
        WEB_IMAGE_4_US,
        WEB_IMAGE_5_US,
        WEB_IMAGE_6_US,
      ]);
    }
  }, [currentLanguage]);

  const loadInitial = async () => {
    try {
      let lResp = await UserService.getListPlan();

      if (lResp) {
        setPlansList(lResp);
      }
    } catch (error) {
      console.warn(error);
    }
  };

  return (
    <React.Fragment>
      <div
        className="site"
        style={{ flexDirection: "column", display: "flex", flex: 1 }}
      >
        <HeaderComponent />
        {/* <HeaderResponsiveComponent /> */}

        <div
          id="home"
          className="site-hero"
          style={{ backgroundImage: `url(${HeroFleetBg})` }}
        >
          <div className="site-hero-content">
            <div className="site-hero-bottom">
              <div className="site-hero-copy">
                <h1>
                  <span>{heroTypedLines[0]}</span>
                  {heroActiveLine === 0 && (
                    <span className="site-hero-type-cursor" aria-hidden="true" />
                  )}
                  <br />
                  <span>{heroTypedLines[1]}</span>
                  {heroActiveLine === 1 && (
                    <span className="site-hero-type-cursor" aria-hidden="true" />
                  )}
                </h1>
                <p>
                  <span>{heroTypedLines[2]}</span>
                  {heroActiveLine === 2 && (
                    <span className="site-hero-type-cursor" aria-hidden="true" />
                  )}
                </p>
              </div>

              <button
                type="button"
                className="site-hero-cta"
                onClick={scrollToFirstSection}
              >
                <span>{t("heroFleetCta")}</span>
                <FiChevronRight aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>

        <div
          ref={userTypesRef}
          className={`user-types ${
            userTypesVisible ? "user-types-visible" : ""
          }`}
        >
          <h2>{t("userTypesSectionTitle")}</h2>
          <div className="user-types-grid">
            <UserTypeCard
              category={t("ownerUserTypeCategory")}
              title={t("ownerUserTypeTitle")}
              description={t("ownerUserTypeDescription")}
            />
            <UserTypeCard
              category={t("pilotUserTypeCategory")}
              title={t("pilotUserTypeTitle")}
              description={t("pilotUserTypeDescription")}
            />
            <UserTypeCard
              category={t("operatorUserTypeCategory")}
              title={t("operatorUserTypeTitle")}
              description={t("operatorUserTypeDescription")}
            />
          </div>
        </div>

        <div className="feature-details-intro">
          <h2>{t("featureDetailsSectionTitle")}</h2>
          <p>{t("featureDetailsSectionDescription")}</p>
        </div>

        <div
          ref={featureDetailsRef}
          className={`feature-details ${
            featureDetailsVisible ? "feature-details-visible" : ""
          }`}
        >
          <div
            className="feature-details-carousel-wrapper"
            onMouseEnter={() => setFeatureDetailsPaused(true)}
            onMouseLeave={() => setFeatureDetailsPaused(false)}
          >
            <button
              type="button"
              className="feature-details-carousel-button"
              aria-label={t("previous")}
              onClick={() => scrollFeatureDetailsCarousel("previous")}
            >
              <FiArrowLeft aria-hidden="true" />
            </button>

            <div
              ref={featureDetailsCarouselRef}
              className="feature-details-carousel"
            >
              <FeatureDetailCard
                title={t("flightPlanningFeatureTitle")}
                items={[
                  t("flightPlanningFeatureItem1"),
                  t("flightPlanningFeatureItem2"),
                  t("flightPlanningFeatureItem3"),
                  t("flightPlanningFeatureItem4"),
                ]}
                buttonText={t("details")}
              />
              <FeatureDetailCard
                title={t("expenseControlFeatureTitle")}
                items={[
                  t("expenseControlFeatureItem1"),
                  t("expenseControlFeatureItem2"),
                  t("expenseControlFeatureItem3"),
                  t("expenseControlFeatureItem4"),
                ]}
                buttonText={t("details")}
              />
              <FeatureDetailCard
                title={t("fuelControlFeatureTitle")}
                texts={[
                  t("fuelControlFeatureText1"),
                  t("fuelControlFeatureText2"),
                  t("fuelControlFeatureText3"),
                ]}
                buttonText={t("details")}
              />
              <FeatureDetailCard
                title={t("interactiveAirportsFeatureTitle")}
                texts={[
                  t("interactiveAirportsFeatureText1"),
                  t("interactiveAirportsFeatureText2"),
                ]}
                buttonText={t("details")}
              />
              <FeatureDetailCard
                title={t("reportsFeatureTitle")}
                texts={[
                  t("reportsFeatureText1"),
                  t("reportsFeatureText2"),
                  t("reportsFeatureText3"),
                ]}
                buttonText={t("details")}
              />
            </div>

            <button
              type="button"
              className="feature-details-carousel-button"
              aria-label={t("next")}
              onClick={() => scrollFeatureDetailsCarousel("next")}
            >
              <FiArrowRight aria-hidden="true" />
            </button>
          </div>
        </div>

        <SolutionSection
          id={"app"}
          category={t("APP")}
          title={t("appSolutionTitle")}
          texts={[
            t("appSolutionParagraph1"),
            t("appSolutionParagraph2"),
            t("appSolutionParagraph3"),
          ]}
          carouselImages={carouselApp}
          carouselMaxWidth={340}
          deviceFrame="phone"
        />

        <div className="app-solution-cta-container">
          <FiPlayCircle type="button" className="app-solution-side-button" />

          <button
            type="button"
            className="app-solution-cta"
            onClick={() => navigate("/app-info")}
          >
            <span>{t("learnMore")}</span>
            <FiArrowRight aria-hidden="true" />
          </button>
        </div>

        <SolutionSection
          id={"web"}
          category={t("WEB")}
          title={t("webSolutionTitle")}
          texts={[
            t("webSolutionParagraph1"),
            t("webSolutionParagraph2"),
            t("webSolutionParagraph3"),
          ]}
          carouselImages={carouselWeb}
          carouselMaxWidth={560}
          deviceFrame="notebook"
        />
        <div className="app-solution-cta-container">
          <FiPlayCircle type="button" className="app-solution-side-button" />

          <button
            type="button"
            className="app-solution-cta"
            onClick={() => navigate("/web-info")}
          >
            <span>{t("learnMore")}</span>
            <FiArrowRight aria-hidden="true" />
          </button>
        </div>

        <DownloadAppSection />

        <LocationSection />

        <FooterComponent />
      </div>
    </React.Fragment>
  );
}
